import actions from './actions'

const initialState = {
  groupsList: [],
  groupsActive: [],
  groupSearchText: '',
  groupMemberSearchText: '',
  groupBannedMemberSearchText: '',
  groupUserSearchText: '',
  userNonGroupsList: [],
  groupMembersList: [],
  groupBannedMembersList: [],
  groupsListTotal: 0,
  groupMembersListTotal: 0,
  groupBannedMembersListTotal: 0,
  groupsFilters: {},
  groupsListPagination: {},
  groupMembersListPagination: [],
  groupBannedMembersListPagination: [],
  groupFriendSearchText: '',
  areGroupsLoading: false,
  groupsModerationList: [],
  groupsModerationListTotal: 0,
  groupsModerationActive: [],
  groupModerationSearchText: '',
  groupMessageLogs: [],
  groupMessageLogsLoading: false,
  nonParticipantSearchText: '',
  nonParticipantsList: [],
  nonParticipantsListTotal: 0,
  nonParticipantsListPagination: {},
  groupScopePermissionsList: [],
  groupScopePermissionsListTotal: 0,
  groupScopePermissionsValues: {},
}

export default function groupsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
